import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { SpineManager } from "../../game/manager/SpineManager";
import { EventHandler } from "../../util/event/EventHandler";
/*
 * SkeletonRequest.ts
 */
export class SkeletonRequest {
    constructor(url) {
        this.url = url;
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_XML);
        this.request.setResponseType(RequestConstants.JSON);
        this.request.onComplete(this.handleComplete, this);
        this.request.onError(this.handleError, this);
        this.request.send();
    }
    handleComplete() {
        SpineManager.getInstance().preload(this.url, this.request.getResponse());
        this.completeHandler.call(this);
    }
    handleError() {
        this.completeHandler.call(this);
    }
    getResponseText() {
        return this.request.getRequest().responseText;
    }
}
//# sourceMappingURL=SkeletonRequest.js.map